import React from 'react';
import { Grid, MenuItem, Typography } from '@mui/material';
import SpectrumTextField from '../../components/Spectrum/TextField/SpectrumTextField';
import SpectrumSelectField from '../../components/Spectrum/Select/SpectrumSelect';
import { STATE_CODES } from '../../constants/common';
import {
  IBillingAddress,
  INewPaymentBankAccountErrorDetails,
  INewPaymentCardErrorDetails,
} from '../../types';

interface IBillingAddressProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  details: IBillingAddress;
  errorDetails: INewPaymentCardErrorDetails | INewPaymentBankAccountErrorDetails;
  isMobileView: boolean;
}

const PaymentBillingAddress = ({
  details,
  errorDetails,
  handleChange,
  isMobileView,
}: IBillingAddressProps) => {
  return (
    <div>
      <Typography variant='h4' sx={{ mt: 14, mb: 10 }}>
        Billing Information
      </Typography>
      <Grid container spacing={8}>
        <Grid item width='100%' small={12}>
          <SpectrumTextField
            required
            label='Name'
            variant='outlined'
            size='small'
            name='customerName'
            onChange={handleChange}
            value={details?.customerName}
            error={!!errorDetails?.customerName}
            helperText={errorDetails?.customerName}
          />
        </Grid>
        <Grid item width='100%' small={isMobileView ? 12 : 6}>
          <SpectrumTextField
            required
            label='Address Line 1'
            variant='outlined'
            size='small'
            name='customerAddress1'
            onChange={handleChange}
            value={details?.customerAddress1}
            error={!!errorDetails?.customerAddress1}
            helperText={errorDetails?.customerAddress1}
          />
        </Grid>
        <Grid item width='100%' small={isMobileView ? 12 : 6}>
          <SpectrumTextField
            label='Address Line 2'
            variant='outlined'
            size='small'
            name='customerAddress2'
            onChange={handleChange}
            value={details?.customerAddress2}
            error={!!errorDetails?.customerAddress2}
            helperText={errorDetails?.customerAddress2}
          />
        </Grid>
        <Grid item small={isMobileView ? 12 : 4} width='100%'>
          <SpectrumSelectField
            required
            label='State'
            variant='outlined'
            size='small'
            name='customerState'
            placeholder='select'
            onChange={handleChange}
            value={details?.customerState}
            error={!!errorDetails?.customerState}
            helperText={errorDetails?.customerState}
          >
            {STATE_CODES.map((item) => (
              <MenuItem key={item?.value} value={item?.value}>
                {item?.label}
              </MenuItem>
            ))}
          </SpectrumSelectField>
        </Grid>
        <Grid item small={isMobileView ? 12 : 4} width='100%'>
          <SpectrumTextField
            required
            label='City'
            variant='outlined'
            size='small'
            name='customerCity'
            onChange={handleChange}
            value={details?.customerCity}
            error={!!errorDetails?.customerCity}
            helperText={errorDetails?.customerCity}
          />
        </Grid>
        <Grid item small={isMobileView ? 12 : 4} width='100%'>
          <SpectrumTextField
            required
            label='Zip'
            variant='outlined'
            size='small'
            name='customerZIP'
            onChange={handleChange}
            value={details?.customerZIP}
            error={!!errorDetails?.customerZIP}
            helperText={errorDetails?.customerZIP}
          />
        </Grid>
      </Grid>
    </div>
  );
};
export default PaymentBillingAddress;
